<template>
  <div class="row pricelist-fields-form">
    <div
      v-for="field in fieldNames"
      :key="field"
      class="col-md-6"
    >
      <div class="form-group" v-if="isBooleanField(field)">
        <label class="pricelist-fields-form__bool-label">
          <input
            type="checkbox"
            :checked="Boolean(formData[field])"
            :disabled="fieldDisabled(field)"
            @change="onBoolChange(field, $event.target.checked)"
          >
          {{ fieldLabel(field) }}
        </label>
      </div>

      <div class="form-group" v-else-if="isJsonField(field)">
        <label>{{ fieldLabel(field) }}</label>
        <textarea
          class="form-control"
          rows="3"
          :value="formText[field]"
          :placeholder="fieldLabel(field)"
          :disabled="fieldDisabled(field)"
          @input="onJsonInput(field, $event.target.value)"
        />
        <small v-if="jsonHint" class="help-block">{{ jsonHint }}</small>
      </div>

      <div class="form-group" v-else>
        <label>{{ fieldLabel(field) }}</label>
        <input
          type="text"
          class="form-control"
          :value="formData[field]"
          :placeholder="fieldLabel(field)"
          :disabled="fieldDisabled(field)"
          @input="onTextInput(field, $event.target.value)"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PricelistFieldsForm',
  props: {
    fieldNames: {
      type: Array,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    formText: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    booleanFields: {
      type: Array,
      default: () => []
    },
    jsonFields: {
      type: Array,
      default: () => []
    },
    jsonHint: {
      type: String,
      default: ''
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    readOnlyFields: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    booleanSet () {
      return new Set(this.booleanFields || [])
    },
    jsonSet () {
      return new Set(this.jsonFields || [])
    },
    readOnlySet () {
      return new Set(this.readOnlyFields || [])
    }
  },
  methods: {
    fieldLabel (field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field)
      return field
    },
    fieldDisabled (field) {
      return this.disabled || this.readOnlySet.has(field)
    },
    isBooleanField (field) {
      return this.booleanSet.has(field)
    },
    isJsonField (field) {
      return this.jsonSet.has(field)
    },
    onBoolChange (field, checked) {
      this.$set(this.formData, field, checked)
    },
    onTextInput (field, value) {
      this.$set(this.formData, field, value)
    },
    onJsonInput (field, value) {
      this.$set(this.formText, field, value)
    }
  }
}
</script>

<style scoped>
.pricelist-fields-form__bool-label {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Pricelist/PricelistFieldsForm.vue